import {BaseEntityUnDeletable} from '../../../common/entities';

export class Rank extends BaseEntityUnDeletable {
  description: string;
}
